import { HeroContent } from "./hero/HeroContent";

export const HeroSection = () => {
  return (
    <section id="hero" className="pt-28 md:pt-36 pb-20 md:pb-28 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <HeroContent />
      </div>
    </section>
  );
};
